import React, { Component } from "react";
import Story from "../parent-section/story-page/Story";

export default class SampleStory extends Component {

  blog = {
        "openCount": 0,
        "isFreeBlog": true,
        "hideBlog": false,
        "_id": "6443e21738bbc614c9b1d183",
        "title": "Meendu shows Kindness towards Mr. John & Daisy",
        "content": {
            "ops": [
                {
                    "attributes": {
                        "color": "#ff02b4",
                        "size": "large",
                        "bold": true
                    },
                    "insert": "I Spy Kindness: Meendu shows Kindness towards Mr. John & Daisy"
                },
                {
                    "attributes": {
                        "align": "center",
                        "header": 1
                    },
                    "insert": "\n"
                },
                {
                    "attributes": {
                        "align": "justify"
                    },
                    "insert": "\n"
                },
                {
                    "attributes": {
                        "bold": true
                    },
                    "insert": "You can browse through the “Characters” section on our website before starting storytime with your child, as it will help them understand the characters better."
                },
                {
                    "attributes": {
                        "align": "justify"
                    },
                    "insert": "\n\n"
                },
                {
                    "insert": "Let’s hear a story of kindness today. Every time we witness an act of kindness, we say: "
                },
                {
                    "attributes": {
                        "italic": true
                    },
                    "insert": "“"
                },
                {
                    "attributes": {
                        "italic": true,
                        "color": "#ff02b4",
                        "bold": true
                    },
                    "insert": "I SPY KINDNESS"
                },
                {
                    "attributes": {
                        "italic": true
                    },
                    "insert": ".”"
                },
                {
                    "insert": " "
                },
                {
                    "attributes": {
                        "align": "justify"
                    },
                    "insert": "\n\n"
                },
                {
                    "insert": "Once upon a time, far, far away, in an ice cream land, there lived an ice cream named Meendu. He was a kind and friendly child. One day as he was leaving for school, he saw Mr. John, the "
                },
                {
                    "attributes": {
                        "bold": true
                    },
                    "insert": "trash picker"
                },
                {
                    "insert": ", cleaning outside his home. Mr. John seemed to be tired of working under the "
                },
                {
                    "attributes": {
                        "bold": true
                    },
                    "insert": "blazing"
                },
                {
                    "insert": " sun."
                },
                {
                    "attributes": {
                        "align": "justify"
                    },
                    "insert": "\n\n"
                },
                {
                    "insert": "Meendu went up to Mr. John and said, “"
                },
                {
                    "attributes": {
                        "italic": true
                    },
                    "insert": "Hello Mr. John. How are you?”"
                },
                {
                    "attributes": {
                        "align": "justify"
                    },
                    "insert": "\n\n"
                },
                {
                    "insert": "Mr. John replied,"
                },
                {
                    "attributes": {
                        "italic": true
                    },
                    "insert": " “I’m good, Meendu. Are you on your way to school?”"
                },
                {
                    "attributes": {
                        "align": "justify"
                    },
                    "insert": "\n\n"
                },
                {
                    "attributes": {
                        "italic": true
                    },
                    "insert": "“Yes, I am. You seem tired, sir.”, "
                },
                {
                    "insert": "said Meendu."
                },
                {
                    "attributes": {
                        "align": "justify"
                    },
                    "insert": "\n\n"
                },
                {
                    "insert": "Mr. John tiredly replied, "
                },
                {
                    "attributes": {
                        "italic": true
                    },
                    "insert": "“Thank you for asking Meendu. The heat makes it a little difficult to work sometimes.”"
                },
                {
                    "attributes": {
                        "align": "justify"
                    },
                    "insert": "\n\n"
                },
                {
                    "insert": "Meendu took out his water bottle and offered it to Mr. John, saying, “"
                },
                {
                    "attributes": {
                        "italic": true
                    },
                    "insert": "Here, Mr. John. Have some water. You might feel better.”"
                },
                {
                    "attributes": {
                        "align": "justify"
                    },
                    "insert": "\n\n"
                },
                {
                    "insert": "Mr. John was "
                },
                {
                    "attributes": {
                        "bold": true
                    },
                    "insert": "overwhelmed"
                },
                {
                    "insert": " to see such a little kid filled with kindness. He said, "
                },
                {
                    "attributes": {
                        "italic": true
                    },
                    "insert": "“Thank you so much, Meendu. You are very kind.”"
                },
                {
                    "attributes": {
                        "align": "justify"
                    },
                    "insert": "\n"
                },
                {
                    "insert": "            "
                },
                {
                    "attributes": {
                        "align": "center"
                    },
                    "insert": "\n"
                },
                {
                    "insert": {
                        "image": "https://meendutoons-static-bucket.s3.ap-south-1.amazonaws.com/imgs/stories/test/675x380.png"
                    }
                },
                {
                    "attributes": {
                        "align": "center"
                    },
                    "insert": "\n"
                },
                {
                    "insert": "         "
                },
                {
                    "attributes": {
                        "align": "center"
                    },
                    "insert": "\n"
                },
                {
                    "attributes": {
                        "bold": true
                    },
                    "insert": "What do we say here???"
                },
                {
                    "attributes": {
                        "align": "center"
                    },
                    "insert": "\n"
                },
                {
                    "attributes": {
                        "bold": true
                    },
                    "insert": "We say, “"
                },
                {
                    "attributes": {
                        "color": "#ff02b4",
                        "bold": true
                    },
                    "insert": "I SPY KINDNESS"
                },
                {
                    "attributes": {
                        "bold": true
                    },
                    "insert": ".”"
                },
                {
                    "attributes": {
                        "align": "center"
                    },
                    "insert": "\n"
                },
                {
                    "attributes": {
                        "align": "justify"
                    },
                    "insert": "\n"
                },
                {
                    "insert": "Meendu waved Mr. John Goodbye and headed towards his school. Meendu was in elementary school and had a lot of friends. He, along with his classmates"
                },
                {
                    "attributes": {
                        "color": "black"
                    },
                    "insert": ", sat"
                },
                {
                    "insert": " in the classroom when the teacher entered. All the children stood up and wished her almost in a singing manner, "
                },
                {
                    "attributes": {
                        "italic": true
                    },
                    "insert": "“Good Morning Ma’aaaam.”"
                },
                {
                    "attributes": {
                        "align": "justify"
                    },
                    "insert": "\n\n"
                },
                {
                    "insert": "The teacher smiled and said, "
                },
                {
                    "attributes": {
                        "italic": true
                    },
                    "insert": "“Good morning, children. Please sit down.”"
                },
                {
                    "attributes": {
                        "align": "justify"
                    },
                    "insert": "\n\n"
                },
                {
                    "insert": "As it was a beautiful morning and everyone was cheerful, the teacher decided to teach colors with a special song."
                },
                {
                    "attributes": {
                        "align": "justify"
                    },
                    "insert": "\n"
                },
                {
                    "insert": "She said, “"
                },
                {
                    "attributes": {
                        "italic": true
                    },
                    "insert": "We’ll learn about colors today! I have a song for you on colors. Would you like to hear it?”"
                },
                {
                    "insert": " (You can ask your child and wait for their response)"
                },
                {
                    "attributes": {
                        "align": "justify"
                    },
                    "insert": "\n\n"
                },
                {
                    "insert": "Teacher sang: (You may sing along with your child by adding your own tune to it)"
                },
                {
                    "attributes": {
                        "align": "justify"
                    },
                    "insert": "\n\n"
                },
                {
                    "attributes": {
                        "color": "#0066cc",
                        "italic": true
                    },
                    "insert": "Blue"
                },
                {
                    "attributes": {
                        "color": "#ff9900",
                        "italic": true
                    },
                    "insert": " is the sky"
                },
                {
                    "attributes": {
                        "align": "center"
                    },
                    "insert": "\n"
                },
                {
                    "attributes": {
                        "color": "#66b966",
                        "italic": true
                    },
                    "insert": "Green"
                },
                {
                    "attributes": {
                        "color": "#ff9900",
                        "italic": true
                    },
                    "insert": " are the trees"
                },
                {
                    "attributes": {
                        "align": "center"
                    },
                    "insert": "\n"
                },
                {
                    "attributes": {
                        "color": "#ff9900",
                        "italic": true
                    },
                    "insert": "Oh Meendu, can you pass me "
                },
                {
                    "attributes": {
                        "italic": true,
                        "color": "#ffff00",
                        "bold": true
                    },
                    "insert": "yellow"
                },
                {
                    "attributes": {
                        "color": "#ff9900",
                        "italic": true
                    },
                    "insert": ", please?"
                },
                {
                    "attributes": {
                        "align": "center"
                    },
                    "insert": "\n"
                },
                {
                    "attributes": {
                        "italic": true
                    },
                    "insert": "Meendu giggles and says: Yes Ma’am, here’s yellow!"
                },
                {
                    "attributes": {
                        "align": "center"
                    },
                    "insert": "\n"
                },
                {
                    "attributes": {
                        "italic": true
                    },
                    "insert": "The teacher continues singing -"
                },
                {
                    "attributes": {
                        "align": "center"
                    },
                    "insert": "\n"
                },
                {
                    "attributes": {
                        "color": "#c285ff",
                        "italic": true
                    },
                    "insert": "Purple"
                },
                {
                    "attributes": {
                        "color": "#ff9900",
                        "italic": true
                    },
                    "insert": " are the orchids"
                },
                {
                    "attributes": {
                        "align": "center"
                    },
                    "insert": "\n"
                },
                {
                    "attributes": {
                        "color": "#ff9900",
                        "italic": true
                    },
                    "insert": "And "
                },
                {
                    "attributes": {
                        "color": "#e60000",
                        "italic": true
                    },
                    "insert": "red"
                },
                {
                    "attributes": {
                        "color": "#ff9900",
                        "italic": true
                    },
                    "insert": " are the roses"
                },
                {
                    "attributes": {
                        "align": "center"
                    },
                    "insert": "\n"
                },
                {
                    "attributes": {
                        "color": "#ff9900",
                        "italic": true
                    },
                    "insert": "But which one’s "
                },
                {
                    "attributes": {
                        "italic": true,
                        "color": "#facccc",
                        "bold": true
                    },
                    "insert": "pink"
                },
                {
                    "attributes": {
                        "color": "#ff9900",
                        "italic": true
                    },
                    "insert": "?"
                },
                {
                    "attributes": {
                        "align": "center"
                    },
                    "insert": "\n\n"
                },
                {
                    "insert": "The class raised their pink-"
                },
                {
                    "attributes": {
                        "color": "black"
                    },
                    "insert": " "
                },
                {
                    "insert": "colored pencils."
                },
                {
                    "attributes": {
                        "align": "center"
                    },
                    "insert": "\n"
                },
                {
                    "insert": "The teacher continued singing: "
                },
                {
                    "attributes": {
                        "color": "#ff9900",
                        "italic": true
                    },
                    "insert": "Oh! Everybody knows!"
                },
                {
                    "attributes": {
                        "align": "center"
                    },
                    "insert": "\n"
                },
                {
                    "insert": " "
                },
                {
                    "attributes": {
                        "align": "justify"
                    },
                    "insert": "\n"
                },
                {
                    "attributes": {
                        "italic": true
                    },
                    "insert": "“Very good children! Now let’s draw a flower.”, "
                },
                {
                    "insert": "said the teacher."
                },
                {
                    "attributes": {
                        "align": "justify"
                    },
                    "insert": "\n\n"
                },
                {
                    "insert": "Meendu and his classmates pulled their drawing books and stationery out of their bags. Meendu’s friend Daisy, who sat next to him, also searched for her "
                },
                {
                    "attributes": {
                        "color": "black"
                    },
                    "insert": "colored"
                },
                {
                    "insert": " pencils, but "
                },
                {
                    "attributes": {
                        "color": "black"
                    },
                    "insert": "could not"
                },
                {
                    "insert": " find them. She had forgotten them home. Meendu noticed this and offered his "
                },
                {
                    "attributes": {
                        "color": "black"
                    },
                    "insert": "colored"
                },
                {
                    "insert": " pencils to Daisy."
                },
                {
                    "attributes": {
                        "align": "justify"
                    },
                    "insert": "\n"
                },
                {
                    "insert": " "
                },
                {
                    "attributes": {
                        "align": "justify"
                    },
                    "insert": "\n"
                },
                {
                    "insert": "Daisy said, "
                },
                {
                    "attributes": {
                        "italic": true
                    },
                    "insert": "“Oh! Thank you, Meendu. You are so kind.”"
                },
                {
                    "attributes": {
                        "align": "justify"
                    },
                    "insert": "\n"
                },
                {
                    "insert": "  "
                },
                {
                    "attributes": {
                        "align": "justify"
                    },
                    "insert": "\n"
                },
                {
                    "insert": {
                        "image": "https://meendutoons-static-bucket.s3.ap-south-1.amazonaws.com/imgs/stories/ep1-2.png"
                    }
                },
                {
                    "attributes": {
                        "align": "center"
                    },
                    "insert": "\n"
                },
                {
                    "attributes": {
                        "align": "justify"
                    },
                    "insert": "\n"
                },
                {
                    "attributes": {
                        "bold": true
                    },
                    "insert": "What do we say here???"
                },
                {
                    "attributes": {
                        "align": "center"
                    },
                    "insert": "\n"
                },
                {
                    "attributes": {
                        "bold": true
                    },
                    "insert": "We say “"
                },
                {
                    "attributes": {
                        "color": "#ff02b4",
                        "bold": true
                    },
                    "insert": "I SPY KINDNESS"
                },
                {
                    "attributes": {
                        "bold": true
                    },
                    "insert": "”"
                },
                {
                    "attributes": {
                        "align": "center"
                    },
                    "insert": "\n"
                },
                {
                    "attributes": {
                        "align": "justify"
                    },
                    "insert": "\n"
                },
                {
                    "insert": "So, what did we learn today? (You can ask your child)"
                },
                {
                    "attributes": {
                        "align": "justify"
                    },
                    "insert": "\n\n"
                },
                {
                    "insert": "We learned kindness. Always be kind and don’t forget to smile!"
                },
                {
                    "attributes": {
                        "align": "justify"
                    },
                    "insert": "\n\n\n"
                },
                {
                    "attributes": {
                        "bold": true
                    },
                    "insert": "Words of the day:"
                },
                {
                    "attributes": {
                        "align": "justify"
                    },
                    "insert": "\n\n"
                },
                {
                    "attributes": {
                        "bold": true
                    },
                    "insert": "Trash Picker"
                },
                {
                    "insert": ": someone who collects trash/garbage to dispose it away and helps us keep our surroundings clean."
                },
                {
                    "attributes": {
                        "align": "justify"
                    },
                    "insert": "\n\n"
                },
                {
                    "attributes": {
                        "bold": true
                    },
                    "insert": "Blazing"
                },
                {
                    "insert": ": very bright or shiny."
                },
                {
                    "attributes": {
                        "align": "justify"
                    },
                    "insert": "\n\n"
                },
                {
                    "attributes": {
                        "bold": true
                    },
                    "insert": "Overwhelmed"
                },
                {
                    "insert": ": when someone has such strong feelings (happy, sad, or angry) that they don’t know how to react to it."
                },
                {
                    "attributes": {
                        "align": "justify"
                    },
                    "insert": "\n\n\n"
                },
                {
                    "attributes": {
                        "bold": true
                    },
                    "insert": "Activity Suggestions: "
                },
                {
                    "attributes": {
                        "align": "justify"
                    },
                    "insert": "\n"
                },
                {
                    "insert": "You can try forming sentences with your child using these words in different ways. Using these words during their day-to-day activities will help them remember better."
                },
                {
                    "attributes": {
                        "align": "justify"
                    },
                    "insert": "\n"
                }
            ]
        },
        "contentHTML": "<h1 class=\"ql-align-center\"><strong style=\"color: rgb(255, 2, 180);\" class=\"ql-size-large\">I Spy Kindness: Meendu shows Kindness towards Mr. John &amp; Daisy</strong></h1><p class=\"ql-align-justify\"><br></p><p class=\"ql-align-justify\"><strong class=\"ql-size-large\">You can browse through the “Characters” section on our website before starting storytime with your child, as it will help them understand the characters better.</strong></p><p class=\"ql-align-justify\"><span class=\"ql-size-large\">Let’s hear a story of kindness today. Every time we witness an act of kindness, we say: </span><em class=\"ql-size-large\">“</em><strong style=\"color: rgb(255, 2, 180);\" class=\"ql-size-large\"><em>I SPY KINDNESS</em></strong><em class=\"ql-size-large\">.”</em><span class=\"ql-size-large\"> </span></p><p class=\"ql-align-justify\"><br></p><p class=\"ql-align-justify\"><span class=\"ql-size-large\">Once upon a time, far, far away, in an ice cream land, there lived an ice cream named Meendu. He was a kind and friendly child. One day as he was leaving for school, he saw Mr. John, the </span><strong class=\"ql-size-large\">trash picker</strong><span class=\"ql-size-large\">, cleaning outside his home. Mr. John seemed to be tired of working under the </span><strong class=\"ql-size-large\">blazing</strong><span class=\"ql-size-large\"> sun.</span></p><p class=\"ql-align-justify\"><br></p><p class=\"ql-align-justify\"><span class=\"ql-size-large\">Meendu went up to Mr. John and said, “</span><em class=\"ql-size-large\">Hello Mr. John. How are you?”</em></p><p class=\"ql-align-justify\"><span class=\"ql-size-large\">Mr. John replied,</span><em class=\"ql-size-large\"> “I’m good, Meendu. Are you on your way to school?”</em></p><p class=\"ql-align-justify\"><em class=\"ql-size-large\">“Yes, I am. You seem tired, sir.”, </em><span class=\"ql-size-large\">said Meendu.</span></p><p class=\"ql-align-justify\"><span class=\"ql-size-large\">Mr. John tiredly replied, </span><em class=\"ql-size-large\">“Thank you for asking Meendu. The heat makes it a little difficult to work sometimes.”</em></p><p class=\"ql-align-justify\"><span class=\"ql-size-large\">Meendu took out his water bottle and offered it to Mr. John, saying, “</span><em class=\"ql-size-large\">Here, Mr. John. Have some water. You might feel better.”</em></p><p class=\"ql-align-justify\"><span class=\"ql-size-large\">Mr. John was </span><strong class=\"ql-size-large\">overwhelmed</strong><span class=\"ql-size-large\"> to see such a little kid filled with kindness. He said, </span><em class=\"ql-size-large\">“Thank you so much, Meendu. You are very kind.”</em></p><p class=\"ql-align-center\"><span class=\"ql-size-large\">&nbsp;           </span></p><p class=\"ql-align-center\"><br></p><p class=\"ql-align-center\"><br></p><p class=\"ql-align-center\"><span class=\"ql-size-large\">         </span></p><p class=\"ql-align-center\"><strong class=\"ql-size-large\">What do we say here???</strong></p><p class=\"ql-align-center\"><strong class=\"ql-size-large\">We say, “</strong><strong style=\"color: rgb(255, 2, 180);\" class=\"ql-size-large\">I SPY KINDNESS</strong><strong class=\"ql-size-large\">.”</strong></p><p class=\"ql-align-center\"><br></p><p class=\"ql-align-justify\"><span class=\"ql-size-large\">&nbsp;</span></p><p class=\"ql-align-justify\"><span class=\"ql-size-large\">Meendu waved Mr. John Goodbye and headed towards his school. Meendu was in elementary school and had a lot of friends. He, along with his classmates</span><span style=\"color: black;\" class=\"ql-size-large\">, sat</span><span class=\"ql-size-large\"> in the classroom when the teacher entered. All the children stood up and wished her almost in a singing manner, </span><em class=\"ql-size-large\">“Good Morning Ma’aaaam.”</em></p><p class=\"ql-align-justify\"><span class=\"ql-size-large\">The teacher smiled and said, </span><em class=\"ql-size-large\">“Good morning, children. Please sit down.”</em></p><p class=\"ql-align-justify\"><span class=\"ql-size-large\">As it was a beautiful morning and everyone was cheerful, the teacher decided to teach colours with a special song.</span></p><p class=\"ql-align-justify\"><span class=\"ql-size-large\">She said, “</span><em class=\"ql-size-large\">We’ll learn about colours today! I have a song for you on colours. Would you like to hear it?”</em><span class=\"ql-size-large\"> (You can ask your child and wait for their response)</span></p><p class=\"ql-align-justify\"><span class=\"ql-size-large\">&nbsp;Teacher sang: (You may sing along with your child by adding your own tune to it)</span></p><p class=\"ql-align-center\"><em class=\"ql-size-large\">Blue is the sky,</em></p><p class=\"ql-align-center\"><em class=\"ql-size-large\">Green are the trees</em></p><p class=\"ql-align-center\"><em class=\"ql-size-large\">Oh Meendu, can you pass me yellow, please?</em></p><p class=\"ql-align-center\"><em class=\"ql-size-large\">Meendu giggles and says: Yes Ma’am, here’s yellow!</em></p><p class=\"ql-align-center\"><em class=\"ql-size-large\">The teacher continues singing -</em></p><p class=\"ql-align-center\"><em class=\"ql-size-large\">Purple are the orchids</em></p><p class=\"ql-align-center\"><em class=\"ql-size-large\">And red are the roses</em></p><p class=\"ql-align-center\"><em class=\"ql-size-large\">But which one’s Pink?</em></p><p class=\"ql-align-center\"><span class=\"ql-size-large\">The class raised their pink-</span><span style=\"color: black;\" class=\"ql-size-large\"> </span><span class=\"ql-size-large\">coloured pencils.</span></p><p class=\"ql-align-center\"><span class=\"ql-size-large\">The teacher continued singing: </span><em class=\"ql-size-large\">Oh! Everybody knows!</em></p><p class=\"ql-align-justify\"><span class=\"ql-size-large\">&nbsp;</span></p><p class=\"ql-align-justify\"><em class=\"ql-size-large\">“Very good children! Now let’s draw a flower.”, </em><span class=\"ql-size-large\">said the teacher.</span></p><p class=\"ql-align-justify\"><span class=\"ql-size-large\">Meendu and his classmates pulled their drawing books and stationery out of their bags. Meendu’s friend Daisy, who sat next to him, also searched for her </span><span style=\"color: black;\" class=\"ql-size-large\">coloured</span><span class=\"ql-size-large\"> pencils, but </span><span style=\"color: black;\" class=\"ql-size-large\">could not</span><span class=\"ql-size-large\"> find them. She had forgotten her </span><span style=\"color: black;\" class=\"ql-size-large\">coloured</span><span class=\"ql-size-large\"> pencils home. Meendu noticed this and offered his </span><span style=\"color: black;\" class=\"ql-size-large\">coloured</span><span class=\"ql-size-large\"> pencils to Daisy.</span></p><p class=\"ql-align-justify\"><span class=\"ql-size-large\">&nbsp;</span></p><p class=\"ql-align-justify\"><span class=\"ql-size-large\">Daisy said, </span><em class=\"ql-size-large\">“Oh! Thank you, Meendu. You are so kind.”</em></p><p class=\"ql-align-justify\"><span class=\"ql-size-large\">  </span></p><p class=\"ql-align-justify\"><strong class=\"ql-size-large\">&nbsp;</strong></p><p class=\"ql-align-justify\"><br></p><p class=\"ql-align-justify\"><br></p><p class=\"ql-align-center\"><strong class=\"ql-size-large\">What do we say here???</strong></p><p class=\"ql-align-center\"><strong class=\"ql-size-large\">We say “</strong><strong style=\"color: rgb(255, 2, 180);\" class=\"ql-size-large\">I SPY KINDNESS</strong><strong class=\"ql-size-large\">”</strong></p><p class=\"ql-align-center\"><br></p><p class=\"ql-align-justify\"><span class=\"ql-size-large\">&nbsp;So, what did we learn today? (You can ask your child)</span></p><p class=\"ql-align-justify\"><span class=\"ql-size-large\">We learned kindness. Always be kind and don’t forget to smile!</span></p><p class=\"ql-align-justify\"><br></p><p class=\"ql-align-justify\"><strong class=\"ql-size-large\">Words of the day:</strong></p><p class=\"ql-align-justify\"><br></p><p class=\"ql-align-justify\"><strong class=\"ql-size-large\">Trash Picker</strong><span class=\"ql-size-large\">: someone who collects trash/garbage to dispose it away and helps us keep our surroundings clean.</span></p><p class=\"ql-align-justify\"><br></p><p class=\"ql-align-justify\"><strong class=\"ql-size-large\">Blazing</strong><span class=\"ql-size-large\">: very bright or shiny.</span></p><p class=\"ql-align-justify\"><br></p><p class=\"ql-align-justify\"><strong class=\"ql-size-large\">Overwhelmed</strong><span class=\"ql-size-large\">: when someone has such strong feelings (happy, sad, or angry) that they don’t know how to react to it.</span></p><p class=\"ql-align-justify\"><br></p><p class=\"ql-align-justify\"><strong class=\"ql-size-large\">Activity Suggestions: </strong></p><p class=\"ql-align-justify\"><span class=\"ql-size-large\">You can try forming sentences with your child using these words in different ways. Using these words during their day-to-day activities will help them remember better.</span></p>",
        "category": "Kindness",
        "thumbnailLink": "https://meendutoons-static-bucket.s3.ap-south-1.amazonaws.com/imgs/thumbnails/videos-stories/ep1.png",
        "uploadDateTime": "2023-04-22T13:33:11.782Z",
        "__v": 0
    }

  render() {
    return <Story sample sampleBlog={this.blog} id={this.props.match.params.blogId}></Story>;
  }
}
